import Transform from '@ember-data/serializer/transform';
import { A } from '@ember/array';

/**
 * This will allow either arrays or objects, and all objects will be converted into arrays
 */
export default Transform.extend({
  /**
   * @inheritDoc
   */
  deserialize: function(serialized) {
    if (serialized == null) {
      return A();
    }

    if (!Array.isArray(serialized)) {
      let items = A();
      Object.values(serialized).forEach(value => items.push(value));
      return items;
    }

    return serialized;
  },

  /**
   * @inheritDoc
   */
  serialize: function(deserialized) {
    throw new Error('not yet supported');
  }
});
